var tr = {
  "Add Upsell.com to your ": "Upsell.com'u ekleyin: ",
  "All time": "Tüm zamanlar",
  "and select": "ve seçin",
  "button": "",
  "Cart drawer page": "Sepet çekmecesi sayfası",
  "Cart page": "Sepet sayfası",
  "Check status": "Durumu kontrol et",
  "Checkout page": "Ödeme sayfası",
  "Click": "Tıklayın",
  "Click on": "Tıklayın",
  "Click the": "Düğmeye tıklayın",
  "Custom slot": "Özel Yuva",
  "Custom slots": "Özel Yuvalar",
  "Custom Slots": "Özel Yuvalar",
  "contact support.": "destek ile iletişime geçin.",
  "from the right sidebar": "sağ kenar çubuğundan",
  "Go to your Cart drawer page": "Sepet çekmecesi sayfanıza gidin",
  "Go to your Cart page": "Sepet sayfanıza gidin",
  "Go to your Checkout page": "Ödeme sayfanıza gidin",
  "Go to your Order status page": "Sipariş durumu sayfanıza gidin",
  "Go to your Post purchase page": "Satın alma sonrası sayfanıza gidin",
  "Go to your Product page": "Ürün sayfanıza gidin",
  "Go to your Thank you page": "Teşekkür sayfanıza gidin",
  "items": "öğeler",
  "in the left sidebar": "sol kenar çubuğunda",
  "Last 12 months": "Son 12 ay",
  "Last 30 days": "Son 30 gün",
  "Last 365 days": "Son 365 gün",
  "Last 7 days": "Son 7 gün",
  "Last 90 days": "Son 90 gün",
  "Last month": "Geçen ay",
  "Last year": "Geçen yıl",
  "Make sure": "Emin olun",
  "Need assistance? Contact our support team for help.": "Yardıma mı ihtiyacınız var? Destek ekibimizle iletişime geçin.",
  "Order status page": "Sipariş durumu sayfası",
  "Our app is currently undergoing a bit of magic to enhance your experience.": "Uygulamamız deneyiminizi geliştirmek için şu anda biraz sihir geçiriyor.",
  "Post purchase page": "Satın alma sonrası sayfası",
  "Product page": "Ürün sayfası",
  "Save": "Kaydet",
  "Scroll to the bottom and select": "En alta kaydırın ve seçin",
  "Select": "Seç",
  "Success. Please continue.": "Başarılı. Lütfen devam edin.",
  "Thank you page": "Teşekkür sayfası",
  "The Upsell.com team.": "Upsell.com ekibi.",
  "The Upsell.com widget is not placed on ": "Upsell.com widget'ı ",
  ". Please follow the steps above or ": " sayfasına yerleştirilmemiş. Lütfen yukarıdaki adımları izleyin veya ",
  "Today": "Bugün",
  "toggle is on": "geçiş açık",
  "Total": "Toplam",
  "under": "altında",
  "We apologize for any inconvenience caused,": "Verdiğimiz rahatsızlıktan dolayı özür dileriz,",
  "We apologize for any inconvenience caused.": "Verdiğimiz rahatsızlıktan dolayı özür dileriz.",
  "We'll be done in a few minutes!": "Birkaç dakika içinde bitireceğiz!",
  "We're improving our services!": "Hizmetlerimizi geliştiriyoruz!",
  "Widget already added": "Widget zaten eklendi",
  "Yesterday": "Dün",
  "You placed the widget on the ": "Widget'ı ",
  ", but you didn't save it in Shopify editor. Please go back to ": " sayfasına yerleştirdiniz, ancak Shopify editöründe kaydetmediniz. Lütfen ",
  " and save the changes.": " sayfasına geri dönün ve değişiklikleri kaydedin."
};

export { tr as default };
//# sourceMappingURL=tr.json.js.map
